import type { StorageAdapter } from 'ProdantixSdk/core/types';

export class MemoryStorage implements StorageAdapter {
  private readonly store = new Map<string, string>();

  getItem(key: string): string | null {
    return this.store.get(key) ?? null;
  }

  removeItem(key: string): void {
    this.store.delete(key);
  }

  setItem(key: string, value: string): void {
    this.store.set(key, value);
  }
}

export function webStorage(): StorageAdapter {
  try {
    const candidate = (globalThis as { localStorage?: StorageAdapter }).localStorage;
    if (candidate) {
      const probe = '__pdx_probe__';
      candidate.setItem(probe, '1');
      candidate.removeItem(probe);
      return candidate;
    }
  } catch {
    return new MemoryStorage();
  }
  return new MemoryStorage();
}
